import KeyFactsStatement from "../../components/KeyFactsStatement";
import CommonLayout from "../../components/Layouts/CommonLayout";

const KeyFactsStatementPage = () => {
  return (
    <CommonLayout>
      <KeyFactsStatement />
    </CommonLayout>
  );
};

export default KeyFactsStatementPage;
